module.exports = __webpack_public_path__ + "static/media/Monopoly_E_HC.6e444f64.png";